import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import RegisterOrganization from './pages/RegisterOrganization';
import HomePage from './pages/HomePage';
import Finance from './pages/Finance';
import Cobrancas from './pages/Cobrancas';
import PlanilhaMensal from './pages/PlanilhaMensal';
import BandasOrcamento from './pages/BandasOrcamento';
import Payroll from './pages/Payroll';
import CreateFeedback from './pages/CreateFeedback';
import CreateReverseFeedback from './pages/CreateReverseFeedback';
import FeedbackDetail from './pages/FeedbackDetail';
import ReverseFeedbackDetail from './pages/ReverseFeedbackDetail';
import Cycles from './pages/Cycles';
import Reports from './pages/Reports';
import Users from './pages/Users';
import MyProfile from './pages/MyProfile';
import './App.css';

function App(): React.ReactElement {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/criar-organizacao" element={<RegisterOrganization />} />

          <Route
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="financeiro/folha" element={<Payroll />} />
            <Route path="financeiro/cobrancas" element={<Cobrancas />} />
            <Route path="financeiro/mensal" element={<PlanilhaMensal />} />
            <Route path="financeiro/bandas-orcamento" element={<BandasOrcamento />} />
            <Route path="financeiro" element={<Finance />} />
            <Route path="feedbacks/create" element={<CreateFeedback />} />
            <Route path="feedbacks/reverse/create" element={<CreateReverseFeedback />} />
            <Route path="feedbacks/reverse/:id" element={<ReverseFeedbackDetail />} />
            <Route path="feedbacks/:id" element={<FeedbackDetail />} />
            <Route path="cycles" element={<Cycles />} />
            <Route path="reports" element={<Reports />} />
            <Route path="users" element={<Users />} />
            <Route path="meu-perfil" element={<MyProfile />} />
          </Route>

          <Route path="/feedbacks" element={<Navigate to="/financeiro" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
